<div class="process-payment">
  <main class="ks-card-body ks-p-0" style="height: 100%">
    <div class="ks-stepper">
      <nav class="ks-stepper-tabs ks-mb-10">
        <ng-container *ngFor="let tab of tabs; let idx = index">
          <div [class.active]="idx === selectedIndex" (click)="selectedIndex = idx">
            <span
              class="tab-icon-custom svg-icon ks-pr-2"
              inlineSVG="assets/media/svg/icons/Payment/{{ tab }}.svg"
            ></span>
            {{ tab }}
          </div>
        </ng-container>
      </nav>
      <div class="ks-stepper-content ks-scrollbar-secondary ks-p-0" style="height: 100%">
        <div #top></div>
        <ng-container [ngSwitch]="selectedIndex">
          <ng-template ngxPermissionsOnly="canSelectFromWallet">
            <kt-bridgepay-wallet-selection-payment
              *ngSwitchCase="tabs.indexOf('Wallet')"
              [customerId]="customerId"
              [organization]="organization"
              (methodSelected)="onMethodChosen($event)"
            >
            </kt-bridgepay-wallet-selection-payment>
          </ng-template>
          <ng-template ngxPermissionsOnly="canUseCreditCards">
            <kt-bridgepay-credit-card-form
              *ngSwitchCase="tabs.indexOf('Credit Card')"
              (formSubmit)="onPaymentAdded($event)"
              [showSubmitButton]="false"
              [tenantId]="organization"
              [showSavePaymentMethodOption]="enableWalletModule"
            >
            </kt-bridgepay-credit-card-form>
          </ng-template>
          <ng-template ngxPermissionsOnly="canUseACHBankTransfer">
            <kt-bridgepay-bank-account-form
              *ngSwitchCase="tabs.indexOf('ACH Transfer')"
              (formSubmit)="onPaymentAdded($event)"
              [showSubmitButton]="false"
              [tenantId]="organization"
              [showSavePaymentMethodOption]="enableWalletModule"
            >
            </kt-bridgepay-bank-account-form>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </main>
</div>

